import React, { FunctionComponent } from "react"
import "./LDSRipple.css"

const LDSRipple: FunctionComponent<{}> = () => {
    return (<div className="LDSRipple"><div></div><div></div></div>)
}

export default LDSRipple